export default "__VITE_ASSET__DQe4DNm___"